export class AudioState {
  duration: number;
  currentTime: number;
  isPlaying: boolean;
  canPlay: boolean;
  ended: boolean;
  error: boolean;

  constructor() {
    this.duration = null;
    this.currentTime = null;
    this.isPlaying = false;
    this.canPlay = false;
    this.ended = false;
    this.error = false;
  }
}
